import { j as t } from "./jsx-runtime.js";
import { a as h, c as p } from "./index3.js";
import { p as x } from "./index2.js";
import { h as f } from "./index6.js";
import { F as r } from "./index4.js";
import { lazy as b, Suspense as g } from "react";
import { useChatbotContext as w } from "./useChatbotContext.js";
import "react-dom";
import "./util.js";
import "./ChatbotProvider.js";
const C = {
  modal_container: ({ darkMode: o }) => p`
    z-index: 100;

    & * {
      box-sizing: border-box;
    }

    > div {
      padding: unset;
    }

    & div[role="dialog"] {
      padding: 0;
      background: ${o ? r.black : r.gray.light3};

      > button {
        top: 14px;
      }
    }

    @media screen and (max-width: 1024px) {
      & div[role="dialog"] {
        width: 100%;
      }

      & > div {
        padding: 32px 18px;
      }
    }
  `
}, v = b(
  () => import("./ChatWindow.js").then((o) => ({ default: o.ChatWindow }))
);
function _(o) {
  const { darkMode: e } = x(o.darkMode), { className: d, inputBarId: s, ...l } = o, { closeChat: c, open: i, conversation: m } = w(), u = () => {
    var n;
    return ((n = o.shouldClose) == null ? void 0 : n.call(o)) ?? !0 ? (c(), !0) : !1;
  }, a = s ?? "chatbot-modal-input-bar";
  return /* @__PURE__ */ t.jsx(g, { fallback: null, children: i ? /* @__PURE__ */ t.jsx(
    f,
    {
      className: h(C.modal_container({ darkMode: e }), d),
      open: i,
      size: "large",
      initialFocus: m.error ? void 0 : `#${a}`,
      shouldClose: u,
      children: /* @__PURE__ */ t.jsx(v, { inputBarId: a, ...l })
    }
  ) : null });
}
export {
  _ as ModalView
};
